import { TextField } from '@eleveo/components-react';
import { TFunction } from 'i18next';
import React from 'react';
import { Field } from 'react-final-form';

import { max255chars, required } from '../../utils/validations';
import { composeValidators } from '../../utils/validations/composeValidators';
import { getFieldsInputTag } from './constants';

interface SkillFormProps {
  t: TFunction;
}

export const SkillForm: React.FC<SkillFormProps> = ({ t }) => (
  <Field name="name" validate={composeValidators(required, max255chars)}>
    {({ input, meta }) => (
      <TextField
        className="w-full"
        isRequired
        label={t('form.name')}
        testId={getFieldsInputTag('skill-name')}
        validationState={meta.touched && meta.invalid ? 'invalid' : 'valid'}
        {...input}
      />
    )}
  </Field>
);
